import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../api/axios';

const Account = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
    });

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const validate = () => {
        if (!form.name || !form.email || !form.password)
            return "All fields are required";

        if (form.password.length < 6)
            return "Password must be at least 6 characters";

        if (form.password !== form.confirmPassword)
            return "Passwords do not match";

        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationError = validate();
        if (validationError) {
            setError(validationError);
            return;
        }

        try {
            setLoading(true);
            setError("");

            await api.post("/register", {
                "first_name": form.name,
                "email": form.email,
                "password": form.password,
                "password_confirmation": form.confirmPassword,
                "user_type": "customer"
            });

            alert("Registration successful!");
        } catch (err) {
            setError(err.response?.data?.message || "Registration failed");
        } finally {
            setLoading(false);
        }

    };


    return (
        <section className="account py-80">
            <div className="container container-lg">

                <div className="row gy-4">
                    {/* Register Card Start */}
                    <div className="col-xl-6">
                        <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40">
                            <h6 className="text-xl mb-32">Register</h6>
                            <form onSubmit={handleSubmit}>

                                {error && <p style={{ color: "red" }}>{error}</p>}

                                <div className="mb-24">
                                    <label htmlFor="usernameTwo" className="text-neutral-900 text-lg mb-8 fw-medium" >
                                        Username <span className="text-danger">*</span>{" "}
                                    </label>
                                    <input type="text" className="common-input" id="usernameTwo" name='name' placeholder="Write a username" onChange={handleChange}/>
                                </div>
                                <div className="mb-24">
                                    <label htmlFor="emailTwo" className="text-neutral-900 text-lg mb-8 fw-medium" >
                                        Email address <span className="text-danger">*</span>{" "}
                                    </label>
                                    <input type="email" name='email' className="common-input" id="emailTwo" placeholder="Enter Email Address" onChange={handleChange}/>
                                </div>
                                <div className="mb-24">
                                    <label htmlFor="enter-password" className="text-neutral-900 text-lg mb-8 fw-medium" >
                                        Password <span className="text-danger">*</span>
                                    </label>
                                    <div className="position-relative">
                                        <input type="password" className="common-input" name='password' id="enter-password" placeholder="Enter Password" onChange={handleChange}/>
                                        <span className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ph-eye-slash" id="#enter-password" />
                                    </div>
                                </div>
                                <div className="mb-24">
                                    <label htmlFor="confirm-password" className="text-neutral-900 text-lg mb-8 fw-medium" >
                                        Confirm Password
                                        <span className="text-danger">*</span>
                                    </label>
                                    <div className="position-relative">
                                        <input type="password" name="confirmPassword" className="common-input" id="confirm-password" placeholder="Enter Confirm Password" onChange={handleChange}/>
                                        <span className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ph-eye-slash" id="#confirm-password" />
                                    </div>
                                </div>
                                <div className="my-48">
                                    <p className="text-gray-500">
                                        Your personal data will be used to process your order, support
                                        your experience throughout this website, and for other purposes
                                        described in our
                                        <Link to="#" className="text-main-600 text-decoration-underline">
                                            {" "}
                                            privacy policy
                                        </Link>
                                        .
                                    </p>
                                </div>
                                <div className="mt-48">
                                    <button disabled={loading} type="submit" className="btn btn-main py-18 px-40">
                                        {loading ? "Please wait..." : "Register"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    {/* Register Card End */}
                </div>

            </div>
        </section>

    )
}

export default Account